import React from "react";

/**
 * Generic skeleton block (animated, dark theme).
 * Usage: <Skeleton className="h-6 w-32" />
 */
export function Skeleton({ className = "" }) {
    return (
        <div
            data-testid="skeleton"
            aria-hidden="true"
            className={`animate-pulse rounded-md bg-gradient-to-r from-white/[0.04] via-white/[0.08] to-white/[0.04] ${className}`}
        />
    );
}

/** Tile placeholder for image gallery / archive thumbnails. */
export function SkeletonTile({ className = "" }) {
    return (
        <div
            data-testid="skeleton-tile"
            className={`rounded-md bg-white/[0.03] border border-white/5 overflow-hidden ${className}`}
        >
            <Skeleton className="w-full aspect-[16/10]" />
            <div className="p-3 space-y-2">
                <Skeleton className="h-3 w-2/3" />
                <Skeleton className="h-2 w-1/3" />
            </div>
        </div>
    );
}

/** Card row placeholder (e.g. FAQ items, team members). */
export function SkeletonRow({ className = "" }) {
    return (
        <div
            data-testid="skeleton-row"
            className={`rounded-md bg-white/[0.03] border border-white/5 p-4 space-y-2 ${className}`}
        >
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-1/2" />
        </div>
    );
}

/** Grid of N tiles. */
export function SkeletonGrid({ count = 6, tileClassName = "", className = "" }) {
    return (
        <div
            data-testid="skeleton-grid"
            className={`grid grid-cols-2 md:grid-cols-3 gap-4 ${className}`}
        >
            {Array.from({ length: count }).map((_, i) => (
                <SkeletonTile key={i} className={tileClassName} />
            ))}
        </div>
    );
}
